import { Text } from '@asurion-core/mx-asurion-ui-react';
import styled from 'styled-components';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { usePlaygroundStore } from '../storage';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const SdkCodeSnippet = () => {
  const widgetParams = usePlaygroundStore((state) => state.widgetParams);

  const codeString = `import { loadWidget } from '@asurion-core/widget-client';
  
const widget = await loadWidget({
  /** REQUIRED **/  
  id: '${widgetParams?.id ?? '{{ widget-id }}'}',
  variant: '${widgetParams?.variant ?? '{{ variant }}'}',
  
  /** OPTIONAL **/
  loaderUrl: '${process.env.NX_PUBLIC_WIDGET_LOADER_URL}',
  ${
    widgetParams?.variantOptionOverrides?.[widgetParams?.variant]
      ? `variantOptionOverrides: {
    '${widgetParams?.variant}': ${`{
      ${Object.entries(widgetParams?.variantOptionOverrides?.[widgetParams?.variant] ?? {})
        .map(([key, value]) => {
          return `'${key}': ${typeof value === 'string' ? value : JSON.stringify(value)}`;
        })
        .join(',\n      ')}
    }`}
  }`
      : ''
  }
});`;

  return (
    <SyntaxHighlighter language="javascript" style={a11yDark} wrapLines wrapLongLines>
      {codeString}
    </SyntaxHighlighter>
  );
};

export const SdkIntegration = () => {
  return (
    <Container>
      <Text size={2} as="p">
        The SI Widget can be used within the repo with the{' '}
        <strong>
          <code>@asurion-core/widget-client</code>
        </strong>{' '}
        library.
      </Text>
      <SdkCodeSnippet />
    </Container>
  );
};
